import { AgButton } from 'src/components/ui';

import type { FilterItemProps } from './filterItemTypes';

export default function ReadOnlyFilter({ updateFilter, filter, column, onClose }: FilterItemProps) {
  const colName = column.headerName ?? column.field;

  return (
    <div className="p-2 border-t border-neutral-5">
      {/* A sighted user reads "no inputs" off the empty panel. Nothing in the
          DOM said so, so a screen-reader user heard only a stray Clear button.
          Visually hidden prose is the announcement; there is no native element
          for "this control is set elsewhere". */}
      <p className="sr-only">{colName} is set outside this panel and cannot be edited here. Clear removes it.</p>
      <AgButton variant="destructive-white" onPress={() => updateFilter({ field: filter.field, where: [] })}>
        Clear
      </AgButton>
    </div>
  );
}
